import { ModalProps } from "antd";
import * as React from "react";
import { observer } from "mobx-react-lite";
import { ModalVertFixed } from "src/components/ModalVertFixed";
import { LoaderBox } from "src/components/LoaderBox";
import { EntityCardStore } from "src/pages/EntityCardPage/EntityCardStore";
import { EntityEditor, PropsEntityEditor } from "./EntityEditor";

interface PropsEntityEditorModal {
  store?: EntityCardStore | null;
  modalProps: ModalProps;
  editorProps: Omit<PropsEntityEditor, "store">;
}

export const EntityEditorModal: React.FC<PropsEntityEditorModal> = observer(
  ({ store, modalProps, editorProps }) => (
    <ModalVertFixed
      {...modalProps}
      width="65vw"
      footer={null}
      closable={!store?.onConfirm}
      centered
    >
      {store && (
        <LoaderBox
          remoteData={store.info}
          drawReady={() => <EntityEditor {...editorProps} store={store} />}
        />
      )}
    </ModalVertFixed>
  ),
);
